import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { APP_PATHS } from '@core/constants';
import { TranslateModule } from '@ngx-translate/core';
import { StatCardComponent } from '@custom-components/general/stat-card/stat-card.component';

export interface DashboardKpis {
  totalInstallations: number | null;
  // Left out for a caller who cannot see installations, like the total.
  incompleteInstallations: number | null;
  totalLocations: number;
  totalDevices: number;
  openAlarms: number;
  alarmsLast7Days: number;
}

@Component({
  selector: 'xemex-dashboard-kpi-tiles',
  imports: [RouterLink, StatCardComponent, TranslateModule],
  styleUrl: './dashboard-kpi-tiles.component.scss',
  templateUrl: './dashboard-kpi-tiles.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardKpiTilesComponent {
  kpis = input.required<DashboardKpis>();

  protected readonly APP_PATHS = APP_PATHS;
  protected readonly columns = computed(
    () =>
      4 +
      (this.kpis().totalInstallations !== null ? 1 : 0) +
      (this.kpis().incompleteInstallations !== null ? 1 : 0),
  );
}
